<h2 mat-dialog-title>
  <mat-icon class="dlg-title-icon">{{project.isFolder ? 'folder' : 'map'}}</mat-icon>
  {{project.isFolder ? (isNew ? strings['create_new_folder'] : strings['rename_folder'])
    : (isNew ? strings['new_project'] : strings['rename_project'])}}
</h2>

<mat-dialog-content>
  <div class="flex-col gap-14">
    <mm-field [label]="project.isFolder ? strings['folder_name'] : strings['project_title']">
      <input mmInput maxlength="50" [placeholder]="strings['rename_project_placeholder']"
        [(ngModel)]="project.name" (keyup.enter)="save()">
    </mm-field>
    @if (!hasName()) {
      <span class="mmf-error-msg">{{strings['name_cannot_be_empty']}}</span>
    }

    <mm-field [label]="strings['description']">
      <textarea mmInput rows="3" maxlength="500"
        [placeholder]="strings['description']"
        [(ngModel)]="project.description"></textarea>
    </mm-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="cancel()">{{strings['cancel']}}</button>
  <!-- The main action, filled like every other dialog's: without color it
       drew as plain text, the same weight as Cancel. -->
  <button mat-flat-button color="primary" [disabled]="!hasName()" (click)="save()">{{strings['save']}}</button>
</mat-dialog-actions>
